/* eslint-disable */
const injectFromLibrary = L => {
	const _measureControlId = 'polyline-measure-control';
	const _unicodeClass = 'polyline-measure-unicode-icon';
	let self;
	let unit;
	let A;
	let d;
	let B;
	let x;
	let y;
	let z;
	let latInterpol;
	let diff;
	let distanceSegment;
	let arrLatLngs;
	let lngInterpol;
	let arrArcCoords;
	let arcpoints;
	let iconArrow;
	let arrow;
	let lineNr;
	let circleNr;
	let lineCoords;
	let newLineSegment2;
	let newLineSegment1;

	/**
	 * Polyline Measure class
	 * @extends L.Control
	 */

	L.Control.PolylineMeasure = L.Control.extend({
		/**
		 * Default options for the tool
		 * @type {Object}
		 */
		options: {
			/**
			 * Position to show the control. Possible values are: 'topright', 'topleft', 'bottomright', 'bottomleft'
			 * @type {String}
			 * @default
			 */
			position: 'topleft',
			/**
			 * Which units the distances are displayed in. Possible values are: 'metres', 'landmiles', 'nauticalmiles'
			 * @type {String}
			 * @default
			 */
			unit: 'metres',
			/**
			 * Title for the control going to be switched on
			 * @type {String}
			 * @default
			 */
			measureControlTitleOn: 'Turn on PolylineMeasure',
			/**
			 * Title for the control going to be switched off
			 * @type {String}
			 * @default
			 */
			measureControlTitleOff: 'Turn off PolylineMeasure',
			/**
			 * HTML to place inside the control. This should just be a unicode icon
			 * @type {String}
			 * @default
			 */
			measureControlLabel: '&#8614;',
			/**
			 * Classes to apply to the control
			 * @type {Array}
			 * @default
			 */
			measureControlClasses: [],
			/**
			 * Background color for control when selected
			 * @type {String}
			 * @default
			 */
			backgroundColor: '#8f8',
			/**
			 * Cursor type to show when creating measurements
			 * @type {String}
			 * @default
			 */
			cursor: 'crosshair',
			/**
			 * Clear the measurements on stop
			 * @type {Boolean}
			 * @default
			 */
			clearMeasurementsOnStop: true,
			/**
			 * Show a control to clear all the measurements
			 * @type {Boolean}
			 * @default
			 */
			showMeasurementsClearControl: false,
			/**
			 * Title text to show on the clear measurements control button
			 * @type {String}
			 * @default
			 */
			clearControlTitle: 'Clear Measurements',
			/**
			 * Clear control inner html
			 * @type {String}
			 * @default
			 */
			clearControlLabel: '&times;',
			/**
			 * Collection of classes to add to clear control button
			 * @type {Array}
			 * @default
			 */
			clearControlClasses: [],
			/**
			 * Show a control to change the units of measurements
			 * @type {Boolean}
			 * @default
			 */
			showUnitControl: false,
			/**
			 * Styling settings for the temporary dashed line
			 * @type {Object}
			 */
			tempLine: {
				/**
				 * Dashed line color
				 * @type {String}
				 * @default
				 */
				color: '#00f',
				/**
				 * Dashed line weight
				 * @type {Number}
				 * @default
				 */
				weight: 2
			},
			/**
			 * Styling for the solid line
			 * @type {Object}
			 */
			fixedLine: {
				/**
				 * Solid line color
				 * @type {String}
				 * @default
				 */
				color: '#006',
				/**
				 * Solid line weight
				 * @type {Number}
				 * @default
				 */
				weight: 2
			},
			/**
			 * Style settings for circle marker indicating the starting point of the polyline
			 * @type {Object}
			 */
			startCircle: {
				/**
				 * Color of the border of the circle
				 * @type {String}
				 * @default
				 */
				color: '#000',
				/**
				 * Weight of the circle
				 * @type {Number}
				 * @default
				 */
				weight: 1,
				/**
				 * Fill color of the circle
				 * @type {String}
				 * @default
				 */
				fillColor: '#0f0',
				/**
				 * Fill opacity of the circle
				 * @type {Number}
				 * @default
				 */
				fillOpacity: 1,
				/**
				 * Radius of the circle
				 * @type {Number}
				 * @default
				 */
				radius: 3
			},
			/**
			 * Style settings for all circle markers between startCircle and endCircle
			 * @type {Object}
			 */
			intermedCircle: {
				/**
				 * Color of the border of the circle
				 * @type {String}
				 * @default
				 */
				color: '#000',
				/**
				 * Weight of the circle
				 * @type {Number}
				 * @default
				 */
				weight: 1,
				/**
				 * Fill color of the circle
				 * @type {String}
				 * @default
				 */
				fillColor: '#ff0',
				/**
				 * Fill opacity of the circle
				 * @type {Number}
				 * @default
				 */
				fillOpacity: 1,
				/**
				 * Radius of the circle
				 * @type {Number}
				 * @default
				 */
				radius: 3
			},
			/**
			 * Style settings for circle marker indicating the latest point of the polyline during drawing a line
			 * @type {Object}
			 */
			currentCircle: {
				/**
				 * Color of the border of the circle
				 * @type {String}
				 * @default
				 */
				color: '#000',
				/**
				 * Weight of the circle
				 * @type {Number}
				 * @default
				 */
				weight: 1,
				/**
				 * Fill color of the circle
				 * @type {String}
				 * @default
				 */
				fillColor: '#f0f',
				/**
				 * Fill opacity of the circle
				 * @type {Number}
				 * @default
				 */
				fillOpacity: 1,
				/**
				 * Radius of the circle
				 * @type {Number}
				 * @default
				 */
				radius: 6
			},
			/**
			 * Style settings for circle marker indicating the end point of the polyline
			 * @type {Object}
			 */
			endCircle: {
				/**
				 * Color of the border of the circle
				 * @type {String}
				 * @default
				 */
				color: '#000',
				/**
				 * Weight of the circle
				 * @type {Number}
				 * @default
				 */
				weight: 1,
				/**
				 * Fill color of the circle
				 * @type {String}
				 * @default
				 */
				fillColor: '#f00',
				/**
				 * Fill opacity of the circle
				 * @type {Number}
				 * @default
				 */
				fillOpacity: 1,
				/**
				 * Radius of the circle
				 * @type {Number}
				 * @default
				 */
				radius: 3
			}
		},

		/**
		 * Create a control button
		 * @param {String} 		label		    Label to add
		 * @param {String} 		title			Title to show on hover
		 * @param {Array} 		classesToAdd	Collection of classes to add
		 * @param {Element} 	container		Parent element
		 * @param {Function} 	fn				Callback function to run
		 * @param {Object} 		context			Context
		 * @returns {Element}					Created element
		 * @private
		 */
		_createControl(label, title, classesToAdd, container, fn, context) {
			const anchor = document.createElement('a');
			anchor.innerHTML = label;
			anchor.setAttribute('title', title);
			classesToAdd.forEach(function(c) {
				anchor.classList.add(c);
			});
			L.DomEvent.on(anchor, 'click', fn, context);
			container.appendChild(anchor);
			return anchor;
		},

		/**
		 * Method to fire on add to map
		 * @param {Object} 		map 	Map object
		 * @returns {Element}			Containing element
		 */
		onAdd(map) {
			self = this;
			self._container = document.createElement('div');
			self._container.classList.add('leaflet-bar');
			L.DomEvent.disableClickPropagation(self._container); // otherwise drawing process would instantly start at controls' container or double click would zoom-in map

			let title = self.options.measureControlTitleOn;
			let label = self.options.measureControlLabel;
			let classes = self.options.measureControlClasses;
			if (label.indexOf('&') !== -1) {
				classes.push(_unicodeClass);
			}

			// initialize state
			self._lines = [];
			self._arrArrows = [];
			self._measureControl = self._createControl(
				label,
				title,
				classes,
				self._container,
				self._toggleMeasure,
				self
			);
			self._measureControl.setAttribute('id', _measureControlId);

			if (self.options.showMeasurementsClearControl) {
				title = self.options.clearControlTitle;
				label = self.options.clearControlLabel;
				classes = self.options.clearControlClasses;
				if (label.indexOf('&') !== -1) {
					classes.push(_unicodeClass);
				}
				self._clearMeasureControl = self._createControl(
					label,
					title,
					classes,
					self._container,
					self._clearAllMeasurements,
					self
				);
				self._clearMeasureControl.classList.add(
					'polyline-measure-clearControl'
				);
			}
			if (self.options.showUnitControl) {
				title = `Change units [${self.options.unit}]`;
				if (self.options.unit === 'metres') {
					label = 'm';
				} else if (self.options.unit === 'landmiles') {
					label = 'mi';
				} else {
					label = 'nm';
				}
				classes = [];
				self._unitControl = self._createControl(
					label,
					title,
					classes,
					self._container,
					self._changeUnit,
					self
				);
				self._unitControl.setAttribute('id', 'unitControlId');
			}
			return self._container;
		},

		/**
		 * Toggle the measure functionality on or off
		 * @private
		 */
		_toggleMeasure() {
			self._measuring = !self._measuring;
			if (self._measuring) {
				// if measuring is going to be switched on
				self._measureControl.style.backgroundColor =
					self.options.backgroundColor;
				self._measureControl.title = self.options.measureControlTitleOff;
				self._oldCursor = self._map._container.style.cursor; // save former cursor type
				self._map._container.style.cursor = self.options.cursor;
				self._doubleClickZoom = self._map.doubleClickZoom.enabled(); // save former status of doubleClickZoom
				self._map.doubleClickZoom.disable();
				// create LayerGroup "layerPaint" (only) the first time Measure Control is switched on
				if (!self._layerPaint) {
					self._layerPaint = L.layerGroup().addTo(self._map);
				}
				self._map.on('mousemove', self._mouseMove, self); //  enable listing to 'mousemove', 'click', 'keydown' events
				self._map.on('click', self._mouseClick, self);
				self._map.on('dblclick', self._finishPath, self);
				L.DomEvent.on(document, 'keydown', self._onKeyDown, self);
				self._resetPathVariables();
			} else {
				// if measuring is going to be switched off
				self._measureControl.removeAttribute('style');
				self._measureControl.title = self.options.measureControlTitleOn;
				self._map._container.style.cursor = self._oldCursor;
				self._map.off('mousemove', self._mouseMove, self);
				self._map.off('click', self._mouseClick, self);
				self._map.off('dblclick', self._finishPath, self);
				L.DomEvent.off(document, 'keydown', self._onKeyDown, self);
				if (self._doubleClickZoom) {
					self._map.doubleClickZoom.enable();
				}
				if (self.options.clearMeasurementsOnStop && self._layerPaint) {
					self._clearAllMeasurements();
				}
				// to remove temp. Line if line at the moment is being drawn and not finished while clicking the control
				if (self._cntCircle !== 0) {
					self._finishPath();
				}
			}
		},

		/**
		 * Clear all measurements from the map
		 */
		_clearAllMeasurements() {
			if (self._cntCircle !== undefined && self._cntCircle !== 0) {
				self._finishPath();
			}
			if (self._layerPaint) {
				self._layerPaint.clearLayers();
			}
			self._lines = [];
			self._arrArrows = [];
		},

		_changeUnit() {
			if (self.options.unit === 'metres') {
				self.options.unit = 'landmiles';
				document.getElementById('unitControlId').innerHTML = 'mi';
			} else if (self.options.unit === 'landmiles') {
				self.options.unit = 'nauticalmiles';
				document.getElementById('unitControlId').innerHTML = 'nm';
			} else {
				self.options.unit = 'metres';
				document.getElementById('unitControlId').innerHTML = 'm';
			}
			self._unitControl.title = `Change units [${self.options.unit}]`;
			self._lines.map(function(line) {
				let totalDistance = 0;
				line.points.map(function(point, point_index) {
					if (point_index > 0) {
						const distance = line.points[point_index - 1].distanceTo(
							line.points[point_index]
						);
						totalDistance += distance;
						self._updateTooltipDistance(
							line.tooltips[point_index - 1],
							totalDistance,
							distance
						);
					}
				});
			});
		},

		/**
		 * Event to fire when a keyboard key is depressed.
		 * Currently only watching for ESC key (= keyCode 27). 1st press finishes line, 2nd press turns Measuring off.
		 * @param {Object} e Event
		 * @private
		 */
		_onKeyDown(e) {
			if (e.keyCode === 27) {
				// if NOT drawing a line (= there's no currentCircle)
				if (!self._currentLine) {
					self._toggleMeasure();
				} else {
					self._finishPath(e);
				}
			}
		},

		/**
		 * Get the distance in the format specified in the options
		 * @param {Number} distance Distance to convert
		 * @returns {{value: *, unit: *}}
		 * @private
		 */
		_getDistance(distance) {
			let dist = distance;

			if (self.options.unit === 'nauticalmiles') {
				unit = 'nm';
				if (dist >= 1852000) {
					dist = (dist / 1852).toFixed(0);
				} else if (dist >= 185200) {
					dist = (dist / 1852).toFixed(1);
					// don't use 3 decimal digits, cause especially in countries using the "." as thousands separator a number could optically be confused (e.g. "1.234 nm": is it 1234 nm or 1,234 nm ?)
				} else {
					dist = (dist / 1852).toFixed(2);
				}
			} else if (self.options.unit === 'landmiles') {
				unit = 'mi';
				if (dist >= 1609344) {
					dist = (dist / 1609.344).toFixed(0);
				} else if (dist >= 160934.4) {
					dist = (dist / 1609.344).toFixed(1);
					// don't use 3 decimal digits, cause especially in countries using the "." as thousands separator a number could optically be confused (e.g. "1.234mi": is it 1234mi or 1,234mi ?)
				} else if (dist >= 1609.344) {
					dist = (dist / 1609.344).toFixed(2);
				} else {
					/* else if (dist >= 402.336) {
                dist = (dist/0.9144).toFixed(1);
                unit = "yd";
            } */
					dist = (dist / 0.3048).toFixed(1);
					unit = 'ft';
				}
			} else {
				unit = 'km';
				if (dist >= 1000000) {
					dist = (dist / 1000).toFixed(0);
				} else if (dist >= 100000) {
					dist = (dist / 1000).toFixed(1);
					// don't use 3 decimal digits, cause especially in countries using the "." as thousands separator a number could optically be confused (e.g. "1.234 km": is it 1234 km or 1,234 km ?)
				} else if (dist >= 1000) {
					dist = (dist / 1000).toFixed(2);
				} else {
					dist = dist.toFixed(1);
					unit = 'm';
				}
			}
			return { value: dist, unit };
		},

		/**
		 * Calculate Great-circle Arc (= shortest distance on a sphere like the Earth) between two coordinates
		 * formulas: http://www.edwilliams.org/avform.htm
		 * @private
		 */

		_polylineArc(_from, _to) {
			function _GCinterpolate(f) {
				A = Math.sin((1 - f) * d) / Math.sin(d);
				B = Math.sin(f * d) / Math.sin(d);
				x =
					A * Math.cos(fromLat) * Math.cos(fromLng) +
					B * Math.cos(toLat) * Math.cos(toLng);
				y =
					A * Math.cos(fromLat) * Math.sin(fromLng) +
					B * Math.cos(toLat) * Math.sin(toLng);
				z = A * Math.sin(fromLat) + B * Math.sin(toLat);
				// atan2 better than atan-function cause results are from -pi to +pi
				// => results of latInterpol, lngInterpol always within range -180Â° ... +180Â°  => conversion into values < -180Â° or > + 180Â° has to be done afterwards
				latInterpol =
					(180 / Math.PI) * Math.atan2(z, Math.sqrt(x ** 2 + y ** 2));
				lngInterpol = (180 / Math.PI) * Math.atan2(y, x);
				// don't split polyline if it crosses dateline ( -180Â° or +180Â°).  Without the polyline would look like: +179Â° ==> +180Â° ==> -180Â° ==> -179Â°...
				// algo: if difference lngInterpol-from.lng is > 180Â° there's been an unwanted split from +180 to -180 cause an arc can never span >180Â°
				diff = lngInterpol - (fromLng * 180) / Math.PI;
				function trunc(n) {
					return Math[n > 0 ? 'floor' : 'ceil'](n);
				} // alternatively we could use the new Math.trunc method, but Internet Explorer doesn't know it
				if (diff < 0) {
					lngInterpol -= trunc((diff - 180) / 360) * 360;
				} else {
					lngInterpol -= trunc((diff + 180) / 360) * 360;
				}
				return [latInterpol, lngInterpol];
			}

			function _GCarc(npoints) {
				arrArcCoords = [];
				const delta = 1.0 / (npoints - 1);
				// first point of Arc should NOT be returned
				for (let i = 0; i < npoints; i += 1) {
					const step = delta * i;
					const coordPair = _GCinterpolate(step);
					arrArcCoords.push(coordPair);
				}
				return arrArcCoords;
			}

			let fromLat = _from.lat; // work with with copies of object's elements _from.lat and _from.lng, otherwise they would get modiefied due to call-by-reference on Objects in Javascript
			let fromLng = _from.lng;
			let toLat = _to.lat;
			let toLng = _to.lng;
			fromLat = (fromLat * Math.PI) / 180;
			fromLng = (fromLng * Math.PI) / 180;
			toLat = (toLat * Math.PI) / 180;
			toLng = (toLng * Math.PI) / 180;
			d =
				2.0 *
				Math.asin(
					Math.sqrt(
						Math.sin((fromLat - toLat) / 2.0) ** 2 +
							Math.cos(fromLat) *
								Math.cos(toLat) *
								Math.sin((fromLng - toLng) / 2.0) ** 2
					)
				);
			if (d === 0) {
				arrLatLngs = [[fromLat, fromLng]];
			} else {
				arcpoints = 100; // 100 points = 99 line segments. lower value to make arc less accurate or increase value to make it more accurate.
				arrLatLngs = _GCarc(arcpoints);
			}
			return arrLatLngs;
		},

		/**
		 * Update the tooltip distance
		 * @param {Number} total        Total distance
		 * @param {Number} difference   Difference in distance between 2 points
		 * @private
		 */
		_updateTooltipDistance(tooltip, total, difference) {
			const totalRound = self._getDistance(total);
			const differenceRound = self._getDistance(difference);
			let text;
			if (differenceRound.value > 0) {
				text = `<div class="polyline-measure-tooltip-difference">+${differenceRound.value}&nbsp;${differenceRound.unit}</div>`;
			}
			text += `<div class="polyline-measure-tooltip-total">${totalRound.value}&nbsp;${totalRound.unit}</div>`;
			tooltip._icon.innerHTML = text;
		},

		_drawArrow(arcLine) {
			const self = this;
			const P48 = arcLine[48];
			const P49 = arcLine[49];
			const diffLng4849 = P49[1] - P48[1];
			const diffLat4849 = P49[0] - P48[0];
			const center = [P48[0] + diffLat4849 / 2, P48[1] + diffLng4849 / 2]; // center of Great-circle distance, NOT of the arc on a Mercator map! reason: a) to complicated b) map not always Mercator c) good optical feature to see where real center of distance is not the "virtual" warped arc center due to Mercator projection
			// angle just an aprroximation, which could be somewhat off if Line runs near high latitudes. Use of *geographical coords* for line segment [48] to [49] is best method. Use of *Pixel coords* for just one arc segement [48] to [49] could create for short lines unexact rotation angles, and the use Use of Pixel coords between endpoints [0] to [98] results in even more rotation difference for high latitudes as with geogrpaphical coords-method
			const cssAngle = -Math.atan2(diffLat4849, diffLng4849) * 57.29578; // convert radiant to degree as needed for use as CSS value; cssAngle is opposite to mathematical angle.
			iconArrow = L.divIcon({
				className: '', // to avoid getting a default class with paddings and borders assigned by Leaflet
				iconSize: [16, 16],
				iconAnchor: [8, 8],
				// html : "<img src='iconArrow.png' style='background:green; height:100%; vertical-align:top; transform:rotate("+ cssAngle +"deg)'>" // alternative method by the use of an image instead of a Unicode symbol.
				html: `<div style = 'font-size: 16px; line-height: 16px; vertical-align:top; transform: rotate(${cssAngle}deg)'>&#x27a4;</div>` // best results if iconSize = font-size = line-height and iconAnchor font-size/2 .both values needed to position symbol in center of L.divIcon for all font-sizes.
			});
			arrow = L.marker(center, { icon: iconArrow }).addTo(self._layerPaint);
		},

		/**
		 * Event to fire on mouse move
		 * @param {Object} e Event
		 * @private
		 */
		_mouseMove(e) {
			self._map.on('click', self._mouseClick, self); // necassary for _dragCircle. If switched on already within _dragCircle an unwanted click is fired at the end of the drag.
			if (!e.latlng || !self._currentLine) {
				return;
			}
			const lastPoint = self._currentLine.points.last();
			self._currentLine.tempLine.setLatLngs(
				self._polylineArc(lastPoint, e.latlng)
			);
			const tooltip = self._currentLine.tooltips.last();
			tooltip.setLatLng(e.latlng);
			const distanceSegment = e.latlng.distanceTo(lastPoint);
			self._updateTooltipDistance(
				tooltip,
				self._currentLine.distance + distanceSegment,
				distanceSegment
			);
		},

		_startLine() {
			const icon = L.divIcon({
				className: 'polyline-measure-tooltip',
				iconAnchor: [-4, -4]
			});

			const last = function() {
				return this.slice(-1)[0];
			};

			self._currentLine = {
				points: [],
				tooltips: [],
				markers: [],
				distance: 0,
				tempLine: L.polyline([], {
					// Style of temporary, dashed line while moving the mouse
					color: self.options.tempLine.color,
					weight: self.options.tempLine.weight,
					interactive: false,
					dashArray: '8,8'
				})
					.addTo(self._layerPaint)
					.bringToBack(),
				path: L.polyline([], {
					// Style of fixed, solid line after mouse is clicked
					color: self.options.fixedLine.color,
					weight: self.options.fixedLine.weight,
					interactive: false
				})
					.addTo(self._layerPaint)
					.bringToBack(),
				handleMarkers(latlng) {
					// update style on previous marker
					const oldMarker = this.markers.last();
					if (oldMarker) {
						if (this.markers.length === 1) {
							oldMarker.setStyle(self.options.startCircle);
						} else {
							oldMarker.setStyle(self.options.intermedCircle);
						}
					}

					// add marker for point
					// Style of the circle marking the latest point of the Polyline while still drawing
					const marker = new L.CircleMarker(
						latlng,
						self.options.currentCircle
					).addTo(self._layerPaint);
					marker.cntLine = self._lines.length;
					marker.cntCircle = self._cntCircle;
					self._cntCircle += 1;
					marker.on('mousedown', self._dragCircle, self);
					this.markers.push(marker);
				},
				addPoint(latlng) {
					const lastPoint = this.points.last();
					// ignore points we already have
					if (lastPoint && lastPoint.equals(latlng)) {
						return;
					}
					this.points.push(latlng);
					// update polyline
					if (this.points.length > 1) {
						const arc = self._polylineArc(lastPoint, latlng);
						if (this.points.length > 2) {
							arc.shift();
						}
						this.path.setLatLngs(this.path.getLatLngs().concat(arc));
						// following lines needed especially for Mobile Browsers where we just use mouseclicks. No mousemoves, no tempLine.
						distanceSegment = lastPoint.distanceTo(latlng);
						var tooltip = self._currentLine.tooltips.last();
						self._updateTooltipDistance(
							tooltip,
							this.distance + distanceSegment,
							distanceSegment
						);
						this.distance += distanceSegment;
						self._drawArrow(arc);
						self._arrArrowsCurrentline.push(arrow);
					}

					// update last tooltip with final value
					const lastTooltip = this.tooltips.last();
					if (lastTooltip) {
						lastTooltip.setLatLng(latlng);
					}

					// add new tooltip to update on mousemove
					var tooltip = L.marker(latlng, {
						icon,
						interactive: false
					}).addTo(self._layerPaint);
					this.tooltips.push(tooltip);

					this.handleMarkers(latlng);
				},
				finalize() {
					// clean up tooltip created by last click
					self._layerPaint.removeLayer(this.tooltips.last());
					this.tooltips.pop();
					// clean up temporary line
					self._layerPaint.removeLayer(self._currentLine.tempLine);
					if (this.points.length > 1) {
						this.tooltips
							.last()
							._icon.classList.add('polyline-measure-tooltip-end'); // add Class e.g. another background-color to the Previous Tooltip (which is the last fixed tooltip, cause the moving tooltip is being deleted later)
						// Style of the circle marking the end of the whole Polyline
						this.markers.last().setStyle(self.options.endCircle);
						self._lines.push(this);
						self._arrArrows.push(self._arrArrowsCurrentline);
					} else {
						// if there is only one point, just clean it up
						self._layerPaint.removeLayer(this.markers.last());
					}
					self._resetPathVariables();
				}
			};
			this._currentLine.points.last = last;
			this._currentLine.tooltips.last = last;
			this._currentLine.markers.last = last;
		},

		/**
		 * Event to fire on mouse click
		 * @param {Object} e Event
		 * @private
		 */
		_mouseClick(e) {
			if (!e.latlng) {
				return;
			}

			if (!self._currentLine) {
				self._startLine();
			}
			self._currentLine.addPoint(e.latlng);
		},

		/**
		 * Finish the drawing of the path
		 * @private
		 */
		_finishPath(e) {
			self._currentLine.finalize();
		},

		/**
		 * After completing a path, reset all the values to prepare in creating the next polyline measurement
		 * @private
		 */
		_resetPathVariables() {
			self._cntCircle = 0;
			self._currentLine = null;
			self._arrArrowsCurrentline = [];
		},

		_dragCircle(e1) {
			if (self._measuring && self._cntCircle === 0) {
				// just execute drag-function if Measuring tool is active but no line is being drawn at the moment.
				self._map.dragging.disable(); // turn of moving of the map during drag of a circle
				self._map.off('mousemove', self._mouseMove, self);
				self._map.off('click', self._mouseClick, self);
				const mouseStartingLat = e1.latlng.lat;
				const mouseStartingLng = e1.latlng.lng;
				const circleStartingLat = e1.target._latlng.lat;
				const circleStartingLng = e1.target._latlng.lng;
				self._map.on('mousemove', function(e2) {
					const mouseNewLat = e2.latlng.lat;
					const mouseNewLng = e2.latlng.lng;
					const latDifference = mouseNewLat - mouseStartingLat;
					const lngDifference = mouseNewLng - mouseStartingLng;
					const currentCircleCoords = L.latLng(
						circleStartingLat + latDifference,
						circleStartingLng + lngDifference
					);
					lineNr = e1.target.cntLine;
					circleNr = e1.target.cntCircle;
					e1.target.setLatLng(currentCircleCoords);
					self._lines[lineNr].points[circleNr] = currentCircleCoords;
					lineCoords = self._lines[lineNr].path.getLatLngs(); // get Coords of each Point of the current Polyline
					if (circleNr >= 1) {
						// redraw previous arc just if circle is not starting circle of polyline
						newLineSegment1 = self._polylineArc(
							self._lines[lineNr].points[circleNr - 1],
							currentCircleCoords
						);
						// the next line's syntax has to be used since Internet Explorer doesn't know new spread operator (...) for inserting the individual elements of an array as 3rd argument of the splice method; Otherwise we could write: lineCoords.splice (circleNr*(arcpoints-1), arcpoints, ...newLineSegment1);
						Array.prototype.splice.apply(
							lineCoords,
							[(circleNr - 1) * (arcpoints - 1), arcpoints].concat(
								newLineSegment1
							)
						);
						self._drawArrow(newLineSegment1);
						self._arrArrows[lineNr][circleNr - 1].removeFrom(self._layerPaint);
						self._arrArrows[lineNr][circleNr - 1] = arrow;
					}
					if (circleNr < self._lines[lineNr].points.length - 1) {
						// redraw following arc just if circle is not end circle of polyline
						newLineSegment2 = self._polylineArc(
							currentCircleCoords,
							self._lines[lineNr].points[circleNr + 1]
						);
						Array.prototype.splice.apply(
							lineCoords,
							[circleNr * (arcpoints - 1), arcpoints].concat(newLineSegment2)
						);
						self._drawArrow(newLineSegment2);
						self._arrArrows[lineNr][circleNr].removeFrom(self._layerPaint);
						self._arrArrows[lineNr][circleNr] = arrow;
					}
					self._lines[lineNr].path.setLatLngs(lineCoords);
					if (circleNr > 0) {
						// just update tooltip position if moved circle is 2nd, 3rd, 4th etc. circle of a polyline
						self._lines[lineNr].tooltips[circleNr - 1].setLatLng(
							currentCircleCoords
						);
					}
					let totalDistance = 0;
					// update tooltip texts of each tooltip
					self._lines[lineNr].tooltips.map(function(item, index) {
						const distance = self._lines[lineNr].points[index].distanceTo(
							self._lines[lineNr].points[index + 1]
						);
						totalDistance += distance;
						self._updateTooltipDistance(item, totalDistance, distance);
					});

					self._map.on('mouseup', function() {
						self._resetPathVariables();
						self._map.off('mousemove');
						self._map.dragging.enable();
						self._map.on('mousemove', self._mouseMove, self);
						self._map.off('mouseup');
					});
				});
			}
		}
	});

	//= =====================================================================================

	L.Map.mergeOptions({
		PolylineMeasureControl: false
	});

	L.Map.addInitHook(function() {
		const self = this;
		if (self.options.polylineMeasureControl) {
			self.PMControl = new L.Control.PolylineMeasure();
			self.addControl(self.PMControl);
		}
	});

	L.control.polylineMeasure = function(options) {
		return new L.Control.PolylineMeasure(options);
	};
	//    return L.Control.PolylineMeasure;
	// to allow
	// import PolylineMeasure from 'leaflet.polylinemeasure';
	// const measureControl = new PolylineMeasure();
	// together with
	// import 'leaflet.polylinemeasure';
	// const measureControl = new L.Control.PolylineMeasure();
};

export default L => {
	injectFromLibrary(L);
};
